import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WarrantyState } from './warranty.reducer';

// Select the feature slice
export const selectWarrantyState = createFeatureSelector<WarrantyState>('warrantyReducer');

// Select properties from the feature slice
export const selectWarrantyTypes = createSelector(selectWarrantyState, state => state.warrantyTypes);

export const selectDeficiencyCode = createSelector(selectWarrantyState, state => state.deficiencyCode);

export const selectLocations = createSelector(selectWarrantyState, state => state.locations);

export const selectSelectedCategory = createSelector(selectWarrantyState, state => state.categoryId);

// Selector to get lots for selected projectId
export const selectCategoryLocation = createSelector(
  selectWarrantyState,
  selectSelectedCategory,
  (state, categoryId) => {
    if (!categoryId || !state.categoryLocation || !state.categoryLocation[categoryId]) {
      return [];
    }
    return state.categoryLocation[categoryId];
  }
);
